import { OfferResponse } from '@/api/generated'
import { KeyValuePair } from '@/shared/utils/key-value-pair'

export interface OfferSettingsViewModel {
  lookup: {
    categories: Array<KeyValuePair<number, string>>
    offerTypes: Array<KeyValuePair<number, string>>
    organisations: Array<KeyValuePair<number, string>>
    organisationTypes: Array<KeyValuePair<number, string>>
    sectors: Array<KeyValuePair<number, string>>
  }
  offer: OfferResponse
}

export const EmptyOfferSettingsViewModel: OfferSettingsViewModel = {
  lookup: {
    categories: [],
    offerTypes: [],
    organisations: [],
    organisationTypes: [],
    sectors: [],
  },
  offer: {
    audiences: [],
    categories: [],
    name: '',
    hasReport: false,
    id: -1,
    organisation: {
      categories: [],
      id: -1,
      name: '',
    },
    partners: [],
    reportIsPublished: false,
    resources: [],
  },
}
